import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import BlueOnBlueLabel from './BlueOnBlueLabel';

const Container = styled.div`
    cursor: pointer;
    border-bottom: 1px solid #ccc;
    min-height: 510px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;

    @media (max-width: 1000px) {
        width: 300px;
        height: 300px;
        min-height: 420px;
    }

    div.img {
        width: 400px;
        height: 400px;
        background-image: url(${props => props.imagePath || '/img/Logo_noir.png'});
        background-repeat: no-repeat;
        background-position: center;
        background-size: ${props => props.objectFit === "contain" ?  "66%" : "cover"};
        position: relative;
        border: ${props => props.objectFit === "contain" ? "1px solid #ccc" : "none"};

        @media (max-width: 1000px) {
            width: 300px;
            height: 300px;
        }

        .privacy, .tag {
            font-size: 12px;
            position: absolute;
            top: 10px;
            padding: 0px 10px;
            border-radius: 50px;
            color: black;
        }

        .privacy{
            right: 10px;
            &.true {
                background-color: rgba(118,251,87);
            }
            &.false {
                background-color: #999;
            }
        }

        .tag {
            left: 10px;
            background-color: blue;
            color: white;
        }
    }

    span.title {
        text-transform: uppercase;
        font-weight: 500;
        margin: 10px 0 0px;
        font-size: 24px;
        display: inline-block;
        color: black;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 400px;
        @media (max-width: 1000px) {
            width: 300px;
        }
    }

    span.sub.title {
        font-weight: 300;
        font-size: 18px;
        margin-top: 0;
    }

    div.bottom {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        width: 400px;
        @media (max-width: 1000px) {
            width: 300px;
        }
        margin-bottom: 10px;
        font-size: 12px;
        gap: 10px;

        span.keyinfo {
            color: blue;
            &::first-letter {
                text-transform: uppercase;
            }
        }

        span.category {
            &::first-letter {
                text-transform: uppercase;
            }
            flex-shrink: 0;
            font-size: 12px;
            color: blue;
        }
    }
`;

const Miniature = (props) => {

    const { i18n } = useTranslation('common');

    let objectFit = props.objectFit || "cover";

    if(!props.imagePath){
        objectFit = "contain";
    }

    return (
        <Container onClick={props.onClick} imagePath={props.imagePath} objectFit={objectFit}>
            <div className='top'>
                <div className='img'>
                    {props.tag &&
                        <span className='tag'>{props.tag}</span>
                    }
                    {props.privacy !== undefined && 
                        <span className={props.privacy ? 'privacy true' : 'privacy false'}>{props.privacy ? (i18n.language === "fr" ? "Public" : "Public") : (i18n.language === "fr" ? "Privé" : "Private") }</span>
                    }
                </div>
                <span className='title'>{props.title}</span>
                <span className='sub title'>{props.subtitle}</span>
            </div>
            <div className='bottom'>
                <span className='keyinfo'>{props.keyInfo}</span>
                {props.category && <BlueOnBlueLabel className='category'>{props.category}</BlueOnBlueLabel>}
            </div>
        </Container>
    );
};

export default Miniature;
